module.exports = {
    ACCOUNT_DEFER_PAYMENT_NAVIGATION: "accountDeferPayment",
    ACCOUNT_DETAILS_NAVIGATION: "accountDetails",
    ACCOUNT_MOVEMENT_NAVIGATION: "accountMovement",
    ACCOUNT_MOVEMENTS_NAVIGATION: "accountMovements",
    ACCOUNTS_LANDING_NAVIGATION: "accountsLanding",
    APPLE_PAY_NAVIGATION: 'gotoapplepay',
    ATM_FINDER_NAVIGATION: "atmFinder",
    BIZUM_PAY_NAVIGATION: 'gotobizum',
    CARD_CONTROL_NAVIGATION: "cardControl",
    CARD_DEPOSIT_MONEY_NAVIGATION: "cardDepositMoney",
    CARD_DETAILS_NAVIGATION: "cardDetails",
    CARD_LIMIT_CHANGE: "cardLimitChange",
    CARD_MOVEMENT_NAVIGATION: "cardMovement",
    CARD_MOVEMENTS_NAVIGATION: "cardMovements",
    CARDS_LANDING_NAVIGATION: "cardsLanding",
    EMITED_TRANSFER_MOVEMENT_NAVIGATION: "emitedTransferMovement",
    EXPENSES_NAVIGATION: "expenses",
    FUNDS_LANDING_NAVIGATION: "fundsLanding",
    GOOGLE_PAY_NAVIGATION: 'gotogooglepay',
    HIRE_AHAC_CARD_NAVIGATION: "hireAHACard",
    HIRE_OC_CARD_NAVIGATION: "hireOCCard",
    HIRE_SAVING_ACCOUNT_NAVIGATION: "hireSavingsAccount",
    LOANS_LANDING_NAVIGATION: "loansLanding",
    OPENBANK_PAY_NAVIGATION: 'gotoopenbankpay',
    PASS_NAVIGATION: "pass",
    PROD_URL: 'https://www.openbank.es',
    ROBO_LANDING_NAVIGATION: "roboLanding",
    TRANSFER_NAVIGATION: "transfers",
    USER_PROFILE_NAVIGATION: "userProfile",
    NEW_TAB_CTA_LINKS: [
        'gotoapplepay', 
        'gotogooglepay', 
        'gotobizum', 
        'gotoopenbankpay'
    ],
    CTA_LINKS: {
        APPLE_PAY_EN: 'en/mobile-pay-apple-pay',
        APPLE_PAY_ES: 'pago-movil-apple-pay',
        BIZUM_PAY_EN: 'en/bizum-send-receive-money-mobile',
        BIZUM_PAY_ES: 'bizum-envia-recibe-dinero-movil',
        GOOGLE_PAY_EN: 'en/mobile-pay-google-pay',
        GOOGLE_PAY_ES: 'pago-movil-google-pay',
        OPENBANK_PAY_EN: 'en/mobile-pay-app-wallet',
        OPENBANK_PAY_ES: 'pago-movil-app-wallet',
    }
};